(function( $ ) {
    $(function() {

        // toggle menu icon
        $('.menu-icon').on('click', function () {
          $(this).addClass('opened');
        });
    });
    $(document).ready(function(){
        //match Height
        $('.footer-column').matchHeight();
        $('.footer-column .title-area').matchHeight();
        $('.featured-items-section .title-wrapper').matchHeight();
        $('.featured-items-section .custom-column').matchHeight();
        $('.eq-team').matchHeight();
        $('.videos-section .inner-video-wrapper .title-wrapper').matchHeight();
        
        
        /*$("#homelink").click(function(e){
            e.preventDefault();
            calcRotation(0);
        });

        $("#aboutLink").click(function(e){
            e.preventDefault();
            calcRotation(90);
        });
    
        $("#newsLink").click(function(e){
            e.preventDefault();
            calcRotation(180);
        });

        $("#contactLink").click(function(e){
            e.preventDefault();
            calcRotation(270);//
        });*/
        
        function calcRotation(rot){
            $(".cube").css("transform", "rotateY(-" + rot + "deg)");
        }
        var degreeRotation = 0;
        function animateCube() {
            setInterval(function(){
                if ( degreeRotation < 180 ) {
                    degreeRotation = degreeRotation + 90;
                    calcRotation(degreeRotation);
                }
                else {
                    calcRotation(0);
                    degreeRotation = 0;
                }
            }, 4000);
        }        
        animateCube();
        
        // Get IE or Edge browser version
        var version = detectIE();

        /**
         * detect IE
         * returns version of IE or false, if browser is not Internet Explorer
         */
        function detectIE() {
          var ua = window.navigator.userAgent;

          // Test values; Uncomment to check result вЂ¦

          // IE 10
          // ua = 'Mozilla/5.0 (compatible; MSIE 10.0; Windows NT 6.2; Trident/6.0)';

          // IE 11
          // ua = 'Mozilla/5.0 (Windows NT 6.3; Trident/7.0; rv:11.0) like Gecko';

          // Edge 12 (Spartan)
          // ua = 'Mozilla/5.0 (Windows NT 10.0; WOW64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/39.0.2171.71 Safari/537.36 Edge/12.0';

          // Edge 13
          // ua = 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/46.0.2486.0 Safari/537.36 Edge/13.10586';

          var msie = ua.indexOf('MSIE ');
          if (msie > 0) {
            // IE 10 or older => return version number
            return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
          }

          var trident = ua.indexOf('Trident/');
          if (trident > 0) {
            // IE 11 => return version number
            var rv = ua.indexOf('rv:');
            return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
          }

          /*var edge = ua.indexOf('Edge/');
          if (edge > 0) {
            // Edge (IE 12+) => return version number
            return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
          }*/

          // other browser
          return false;
        }        
        //In IE remove Cube animation and activate simple slider
        $('.text-slider').slick({
            arrows: false,
            dots: false,
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 2000,
            autoplay: true
        });
        if( version !== false ){
            $('.cube-global-wrapper').css({'display': 'none'});
            $('.text-slider-wrapper').css({'display': 'block'});            
        }
        // Quote Section        
        //function for animate content like 'falling down'
        //params is strings selectors: 'sectionSelector', 'movingSelector'
        
        function moveContentBg( sectionSelector, movingSelector ) {
            $(sectionSelector).each(function(){
                var thisSection = $(this);                
                var thisMoving = thisSection.find(movingSelector);
                //console.log(thisMoving);
                var heightQuote = thisMoving.outerHeight();
                
                
                thisSection.height(heightQuote);
                var fixedQuote = thisSection;
                //Scrolling animation
                var docViewTop = $(window).scrollTop();
                var docViewBottom = docViewTop + $(window).height();
                
                $(window).scroll(function () {
                    if( fixedQuote.length > 0 ) {
                        docViewTop = $(window).scrollTop();
                        docViewBottom = docViewTop + $(window).height();

                        var elemHeight = $(fixedQuote).height();
                        //console.log(elemHeight);
                        var elemTop = $(fixedQuote).offset().top;
                        var elemBottom = elemTop + elemHeight;
                        if (((elemTop <= docViewBottom) && (elemBottom >= docViewTop))) {                        
                            var temp = ((docViewTop-elemBottom)/100);                        
                            thisMoving.css({'transform': 'translateY('+ (-temp) + "px)"});

                        }
                        //var b = document.querySelector(sectionSelector).getBoundingClientRect();
                        //var a = document.querySelector(movingSelector).getBoundingClientRect();
                        //For 'this' query selector added [0] as getBoundingClientRect() don't catch jQuery object
                        var b = thisSection[0].getBoundingClientRect();
                        var a = thisMoving[0].getBoundingClientRect();

                          if (b.top <= a.top + a.height+100 && b.top + b.height+100 > a.top) { //range 100px overlapping
                            //console.log('overlap');
                                thisMoving.css('opacity',1);
                                thisMoving.css('visibility','visible');
                          }
                          else {
                              thisMoving.css('opacity',0);
                              thisMoving.css('visibility','hidden');
                          }
                    }
                });                
            });                                                            
        }
        //Animate sections
        //moveContentBg('.quote-section', '.quote-inner-wrapper');        
        //moveContentBg('.call_to_action_section', '.quote-inner-wrapper');
        //moveContentBg('.logos-section', '.quote-inner-wrapper');
        //moveContentBg('.social-icons-section', '.socials-inner-wrapper');
        $(window).resize(function(){
            //Animate sections on window resize
            //moveContentBg('.quote-section', '.quote-inner-wrapper');
            //moveContentBg('.call_to_action_section', '.quote-inner-wrapper');
            //moveContentBg('.logos-section', '.quote-inner-wrapper');
            //moveContentBg('.social-icons-section', '.socials-inner-wrapper');
        });
               
        //Project Section
                        
        //Projects slider
        var projectSliderArgs = {
            arrows: false,
            dots: true,
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 1000,
            autoplay: false,
            adaptiveHeight: true
        };
        //Slider init handler
        $('.project-slider').on('init', function(){
            //set height to absolute blocks parents
            $('.project-section .left-part-pre').each(function() {
                var leftProjectPart = $(this).find('.inner-wrapper').outerHeight();
                var cssTop = $(this).find('.inner-wrapper').css('top');                
                $(this).height(leftProjectPart + parseInt(cssTop) );
            });
        });        
        $('.project-slider').slick(projectSliderArgs);
        $(window).resize(function(){
            $('.project-slider').slick('unslick');
            $('.project-section .left-part-pre').each(function() {
                var leftProjectPart = $(this).find('.inner-wrapper').outerHeight();
                var cssTop = $(this).find('.inner-wrapper').css('top');                
                $(this).height(leftProjectPart + parseInt(cssTop) );
            });
            $('.project-slider').slick(projectSliderArgs);            
        });
        //Text and Image Section
        function calculateTextImgSec() {
            $('.image-with-text-section .inner-wrapper').each(function() {
                var textHeight = $(this).outerHeight();
                var cssTop = $(this).css('top');
                if( $(this).hasClass('last-column') ){
                    $(this).parent().height(textHeight + parseInt(cssTop) );
                }
                else {
                    $(this).parent().height(textHeight + ( parseInt(cssTop) *2 ));                
                }            

            });
        }
        calculateTextImgSec();
        $(window).resize(function(){
            calculateTextImgSec();
        });
        //Team Section
        if( $('.team-section .inner-top').length > 0 ) {
            var cssTopTeam = $('.team-section .inner-top').css('top');
            $('.team-section').css({'padding-top': (-1)*parseInt(cssTopTeam)+"px"});
        }
        if( $('.team-section .inner-bottom').length > 0 ) {
            var cssBottomTeam = $('.team-section .inner-bottom').css('bottom');
            $('.team-section').css({'padding-bottom': (-1)*parseInt(cssBottomTeam)+"px"});
        }
//        //Parallax
//        var windowWidth = $(window).width();
//        var rellax;
//        var destroyed = 0;
//        var resized = $(window).width();
//        if( $('.rellax').length > 0 && windowWidth > 1024 ) {
//            rellax = new Rellax('.rellax');
//        }        
//        $(window).resize(function(){
//            windowWidth = $(window).width();
//            
//            if( $('.rellax').length > 0 && windowWidth > 1024 && destroyed === 1 ) {
//                rellax = new Rellax('.rellax');
//                destroyed = 0;
//            }
//            else if( windowWidth < 1025 && destroyed === 0 && (resized > $(window).width() ) && typeof rellax !== 'undefined' ) {                
//                rellax.destroy();            
//                //$(this).css('transform', 'translate3d(0px, 0px, 0px)');
//                destroyed = 1;
//            }
//            resized = $(window).width();
//        });
        //Default page intro Text
        function calculateDefIntro(){
            var defIntroTextH = $('.default-page-intro-text .inner-wrapper').outerHeight();
            var defIntroTextCssTop = $('.default-page-intro-text .inner-wrapper').css('top');
            $('.default-page-intro-text .inner-wrapper').parent().height(defIntroTextH + parseInt(defIntroTextCssTop) );
        }
        calculateDefIntro();
        $(window).resize(function(){
            calculateDefIntro();
        });
        //Featured Section
        function calculateFeatTitle(){
            $('.featured-items-section .custom-column').each(function(){
                var featTitleH = $(this).find('.title-wrapper').outerHeight();
                $(this).css({'padding-top': featTitleH - 10+'px'});
            });
        }
        calculateFeatTitle();
        $(window).resize(function(){
            calculateFeatTitle();
        });
        //Featured single section
        function calculateFeatTitleSingle(){
            $('.featured-item-big-img-section').each(function(){
                var featTitleHsingle = $(this).find('.title-wrapper').outerHeight();
                //var bigHeight = $(this).outerHeight();
                //$(this).height( bigHeight+featTitleHsingle-10);
                $(this).find('.first-row').css('padding-top', featTitleHsingle - 10+'px');
            });
        }
        calculateFeatTitleSingle();
        $(window).resize(function(){
            calculateFeatTitleSingle();
        });
        //Play Video
        $('.video-section').on('click touchstart', '.play-button', function(){
            $(this).hide();
            var iframeCont = $(this).closest('.video-section').find('iframe');
            iframeCont.show();
            //iframeCont[0].src += "?rel=0&autoplay=1"; //uncomment for autoplay option
        });
        //Word animation
        $(window).load(function(){
            //Animate Home Words
            if( $('.first-text').length > 0 ){
                $('.first-text').animate({
                    opacity: 1,
                    top: 0
                }, 400, function(){
                    $('.small-text').animate({
                        opacity: 1,
                        right: 0
                    }, 400, function(){
                        $('.second-text').animate({
                            opacity: 1,
                            top: 0
                        }, 400, function(){
                            $('.reveal').animate({
                                opacity: 1
                            }, 400, function(){
//                                $('.arrow-block').animate({
//                                    opacity: 1,
//                                    right: 0
//                                }, 400);
                                setTimeout(function(){
//                                    if( $(window).width() > 768 ){
//                                        $('.menu-main-nav-container').addClass('flipped-down');
//                                    }
                                }, 900);
                            }).css({'animation': 'play 1.3s steps(43)'});                            
                        });
                    });
                });
            }
            else {
                $('.menu-main-nav-container').addClass('flipped-down');
            }            
        });
        $(window).resize(function(){
            if( $(window).width() < 769 ){
                $('.menu-main-nav-container').removeClass('flipped-down');
            }
            else {
                $('.menu-main-nav-container').addClass('flipped-down');
            }
        });
        //Header Animation
        var headerMenuHeight = $('.menu-main-nav-container').outerHeight();
        var windowScrollTop = $(window).scrollTop();
        $(window).scroll(function() {
            windowScrollTop = $(window).scrollTop();
            if( windowScrollTop >= headerMenuHeight+50 ) {                
                if( $(window).width() > 768){
                    $('.menu-main-nav-container').addClass('fixed');
                }
            }
            else {
                $('.menu-main-nav-container').removeClass('fixed');
            }
        });
        //Home page Intro
        function calculateHomeIntro(){
            var defIntroTextHH = $('.home-page-intro-text .intro-text-pre-wrapper .intro-text-wrapper').outerHeight();
            //console.log(defIntroTextHH);
            //var defIntroTextCssTopH = $('.home-page-intro-text .intro-text-pre-wrapper .intro-text-wrapper').css('top');
            $('.home-page-intro-text .intro-text-pre-wrapper').height(defIntroTextHH);
        }
        //calculateHomeIntro();
        $(window).resize(function(){
            //calculateHomeIntro();
        });
        //calculate Form Part
        //function cal
        //Mobile menu
        $(".menu-toggler").on('click', function(e){
            e.preventDefault();
            $('.menu-toggler').toggleClass("active");
            $('.nav-icon').toggleClass('open');
            if($('.menu-main-nav-container').hasClass('active')){
                $('.menu-main-nav-container').removeClass('active');
            }
            else {
                $('.menu-main-nav-container').addClass('active');
            }
        });
        //Animation Image Blocks
//        $('.case-images .inner-wrapper').each(function(){
//            if (!/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
//                $(this).viewportChecker({
//                    classToAdd: 'visible animated fadeInUp',
//                    offset: 100
//                });
//            }
//            else {
//                $(this).addClass('visible');
//            }
//        });
        function stopVideo(){
            $('.modal-content').each(function(){
                var iframe = $(this).find("iframe");
                var iframeSrc = iframe.attr("src");
                iframe.attr("src", iframeSrc);
            });
        }        
        $('.btn.video').on('click', function(event){
            event.preventDefault();
            $('.top-image-section').siblings('.modal-pop-up').show();
        });
        $('.inner-video-wrapper .play').on('click', function(){
            $(this).closest('.inner-video-wrapper').find('.modal-pop-up').show();
        });
        $(document).on('click', function(event){
            if( $(event.target).hasClass('modal-pop-up') ) {
                $('.modal-pop-up').hide();
                stopVideo();
            }            
        });
        //Modal Close
        $('.close-btn').on('click', function(){
            $('.modal-pop-up').hide();
            stopVideo();
        });
        $('body').mouseleave(function(){            
            //$('.modalDialog').css({'opacity':'1', 'pointer-events': 'auto'});
        });
        $('.close').on('click', function(){
            //$('.modalDialog').css({'opacity':'0', 'pointer-events': 'none'});
        });
        $('.popup-content .content').each(function(){
            $(this).html(  $(this).siblings('.typed').html() );
        });
        $('.i-sign-open').on('click', function(e){
            e.preventDefault();
            var thisEl = $(this);
            var thisContent = thisEl.closest('.title-wrapper').siblings('.popup-content').find('.typed').html();
            thisContent = String(thisContent);
            thisEl.closest('.title-wrapper').siblings('.popup-overlay, .popup-content').toggleClass('opened');            
            $('body').toggleClass('noScroll');             
            if( !$('.popup-content.opened .content').hasClass('done') ){
                thisEl.closest('.title-wrapper').siblings('.popup-content').find('.content').typeIt({
                    //strings: String(thisContent),
                    speed: 20,
                    html: true,
                    callback: function() {                        
                        $('.popup-content.opened .content').addClass('done');
                        $('.popup-content.opened .btn').fadeIn(500).css('display', 'inline-block');
                   }
               });
            }            
        });
        $('.close-icon').on('click', function(){
            $('.popup-overlay, .popup-content').removeClass('opened');
            $('body').removeClass('noScroll');
            $('.popup-content .content').each(function(){
                if( !$(this).hasClass('done') ){
                    $(this).html(  $(this).siblings('.typed').html() );
                }                
            });
        });
        //Submenus
        $('.arrow-sub').on('click', function(){
            if( !$(this).hasClass('opened') ){
                $('.main-nav>.menu-item-has-children.opened').each(function(){
                    $(this).find('.sub-menu').slideUp();
                    $(this).removeClass('opened');
                    $(this).find('.arrow-sub').removeClass('opened');
                    //$(this).find('.after').removeClass('opened');
                });
            }            
            
            $(this).toggleClass('opened');
            $(this).siblings('.arrow-sub').toggleClass('opened');
            $(this).closest('.menu-item-has-children').toggleClass('opened');
            $(this).siblings('.sub-menu').toggleClass('opened').slideToggle();
        });
        //Video on hover
        $(".team-section-post .inner-wrapper .image-wrapper:not(.pop-up)").hover( hoverVideo, hideVideo );

        function hoverVideo(e) {  
            var thisEl = $('video', this);
            thisEl.get(0).play();            
        }

        function hideVideo(e) {
            var thisEl = $('video', this);
            thisEl.get(0).pause();                   
        }
        //Hide video on mobiles
        if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {            
            $('.image-wrapper.video .thevideo').hide();            
        }
        //scroll to anchors
        $('a[href*=#]:not([href=#])').click(function(e) {            
            if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
                var target = $(this.hash);
                var headerBoxHeight_ = $('.main-nav').outerHeight();
                target = target.length ? target : $('[name=' + this.hash.slice(1) +']');                    
                if (target.length) {
                    $('html,body').animate({
                            scrollTop: target.offset().top - headerBoxHeight_
                    }, 2000);
                    return false;
                }
            }
        });        
        // Filtering
        //Isotope with images loaded
        var $grid = $('.grid').imagesLoaded( function() {
            // init Isotope after all images have loaded
            $grid.isotope({
                itemSelector: '.video-item',
                layoutMode: 'fitRows',
                fitWidth: true,
                gutter: 40,
            });
            $grid.isotope({ filter: '*' });
            $('.single-filter:first-child').addClass('active');
            $('.single-filter').on('click', function(){
                $(this).addClass('active').siblings('.single-filter').removeClass('active');
                var filterValue = $(this).attr('data-filter');
                $grid.isotope({ filter: filterValue });
            });
        });
    });
})(jQuery);